export const TAG_DESCRIPTION = {
	MAX_LENGTH: 500,
	MAX_MESSAGE: 'Tag description cannot exceed 500 characters',
	REQUIRED_MESSAGE: 'Please enter a tag description'
};
